import React, { useEffect, useState, useContext, useRef } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  Modal,
  Dimensions,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
// import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";

import CustomText from "../accessories/CustomText";
import {
  handleAPI,
  updateWebURL,
  handleSessionCheck,
  handleStartNewLoan,
  checkForUpdates,
} from "../accessories/CommonFunctions";
import { context } from "../accessories/accessories";
import { web } from "../accessories/Platform";
import ScrollContainer from "../accessories/ScrollContainer";
import AsyncStorage from "@react-native-async-storage/async-storage";
import packageJson from "../../package.json";
import CircleProgressBar from "./../accessories/CircleBar";

import {
  NavBarContent,
  handleManipulateNavOptions,
  handleProcessNavOptions,
  navOption,
  navOptionEsign,
} from "./NavAccessories";

const { version, buildVersion } = packageJson;

const NavBar = (props) => {
  const {
    WebLoginId = 0,
    handleLogOut = () => {},
    isDashBoard = false,
    isHome = false,
    handleClearState = () => {},
    completedPage = null,
    excludePageIds = [],
    additionalEmploymentList = [],
    pageIndex,
    isSmallScreen,
    isEsignOnly,
    setFloatPage = () => {},
    progressPercentage = 0,
    setProgressPercentage = () => {},
    hideProgress,
    currentPage,
    platformType,
    showEsignMenu,
    webviewRef,
    iFrameviewRef,
    inCompleteTabIndex,
    pageId,
  } = props;
  const isMobileWeb = Dimensions.get("window").width <= 480;
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation, userName = "", loanId, SessionId = "" } = contextDetails;
  const [isNavOpen, setNavOpen] = useState({ left: false, right: false });

  const [navLeftOptionState, setNavLeftOptionState] = useState(navOption | []);
  const leftNavRef = useRef();
  const rightNavRef = useRef();
  const DMLogoBlueRef = useRef();

  const [leftNavPosition, setLeftNavPosition] = useState({
    top: 0,
    left: 0,
    opacity: 0,
  });
  const [rightNavPosition, setRightNavPosition] = useState({
    top: 0,
    left: 0,
    opacity: 0,
  });

  if (web) {
    useEffect(() => {
      leftNavRef?.current?.setNativeProps({
        tabIndex: -1,
      });
    }, [leftNavRef.current]);

    useEffect(() => {
      rightNavRef?.current?.setNativeProps({
        tabIndex: -1,
      });
    }, [rightNavRef.current]);
    useEffect(() => {
      DMLogoBlueRef?.current?.setNativeProps({
        tabIndex: -1,
      });
    }, [DMLogoBlueRef.current]);
  }

  const handleLeftNavOpen = () => {
    leftNavRef.current.measure((_fx, _fy, _w, h, _px, py) => {
      setLeftNavPosition({
        top: py + (web ? 68 : 50),
        left: web ? _px + -15 : 0,
        opacity: 1,
      });
    });
  };
  const handleRightNavOpen = () => {
    rightNavRef.current.measure((_fx, _fy, _w, h, _px, py) => {
      setRightNavPosition({
        top: py + (web ? 73 : 50),
        left: _px + (web ? -165 : -195),
        opacity: 1,
      });
    });
  };
  const handleLogOut_ = async (flag) => {
    setNavOpen({ left: false, right: false });
    handleLogOut(flag);
    if (flag) {
      await handleAPI({
        name: "SaveFaceIdToWebLoginAccount",
        params: { WebLoginId, BioMetric: "" },
      })
        .then(async function (response) {
          await AsyncStorage.removeItem("bioMetricLoginDetails");
          await AsyncStorage.removeItem("Credentials");
        })
        .catch(function (err) {
          console.log(`Error from SaveFaceIdToWebLoginAccount ====>  ${err}`);
        });
    }
  };
  useEffect(() => {
    if (pageIndex) {
      let navBar = navLeftOptionState || navOption;
      navBar = navBar.map((item, index) => {
        item["isExpand"] = index == pageIndex["page"];
        return item;
      });
      setNavLeftOptionState([...[], ...navBar]);
    }
  }, [pageIndex]);

  useEffect(() => {
    handleSessionCheck(SessionId, handleLogOut_);
  }, [SessionId]);

  useEffect(() => {
    if (isHome && completedPage) {
      let updatedArray = [];
      updatedArray = (navLeftOptionState || navOption).map((item, index) => {
        item["Status"] = completedPage.indexOf(index) > -1 ? 1 : 0;
        return item;
      });
      //Get Progress Value

      let checkPages = [1, 3, 4, 5, 6, 10, 13], //2,
        completedCount =
          updatedArray.filter(
            (ele) => ele["Status"] && checkPages.indexOf(ele["Id"]) !== -1
          ).length || 1,
        progressPercentage =
          (100 / checkPages.length) * (loanId > 0 ? completedCount : 0);

      if (progressPercentage == 90) progressPercentage = 95;
      if (progressPercentage < 0) progressPercentage = 0;
      if (progressPercentage > 100) progressPercentage = 100;
      setProgressPercentage(Math.round(progressPercentage));

      updatedArray = handleProcessNavOptions(
        updatedArray,
        pageIndex,
        additionalEmploymentList,
        pageId
      );
      setNavLeftOptionState([...[], ...updatedArray]);
      setNavOpen({ left: false, right: false });
    }
  }, [completedPage]);

  useEffect(() => {
    if (contextDetails.loanId > 0) {
      handleAPI({
        name: "UpdateLoanAppStatus",
        params: {
          LoanId: contextDetails.loanId,
          Status: Math.round(progressPercentage) === 100 ? 1 : 0,
          SessionID: SessionId,
        },
      })
        .then((response) => {
          // log(response);
        })
        .catch((err) =>
          console.error("Error form UpdateLoanAppStatus ====> ", err)
        );
    }
  }, [progressPercentage]);

  useEffect(() => {
    setNavLeftOptionState(
      handleManipulateNavOptions(isEsignOnly, excludePageIds)
    );
  }, [excludePageIds, isEsignOnly]);

  let navLeftOption = [];
  if (isDashBoard) navLeftOption = [{ Name: "My Dashboard" }];
  else {
    if (
      showEsignMenu &&
      currentPage == "eSign" &&
      ["isMobileWeb", "ios", "android"].includes(platformType)
    )
      navLeftOption = [...[{ Name: "My Dashboard" }], ...navOptionEsign];
    else {
      navLeftOption = [
        ...[{ Name: "My Dashboard" }],
        ...(navLeftOptionState || navOption),
      ];
    }
  }

  const handleOpenSettings = () => {
    if (web) {
      setFloatPage({
        path: "Settings",
        option: {
          From: isDashBoard ? "DashBoard" : "Home",
          SessionId,
          WebLoginId,
        },
      });
    } else {
      navigate("Settings", {
        From: isDashBoard ? "DashBoard" : "Home",
        SessionId,
        WebLoginId,
      });
    }
    setNavOpen({ ...isNavOpen, right: false });
  };
  const navRightOption = [
    {
      Name: "Settings",
      onPress: () => {
        handleOpenSettings();
      },
    },
    isMobileWeb &&
      web && {
        Name: "Use Mobile App",
        onPress: () => {
          window.parent.location.href = "https://directmortgage.com/S/f6QTt";
        },
      },
    {
      Name: "Start New Loan App",
      onPress: () => {
        handleClearState(isDashBoard);
        handleStartNewLoan(
          navigation || props["navigation"],
          SessionId,
          userName,
          contextDetails,
          setContextDetails
        );
        setNavOpen({ ...isNavOpen, right: false });
      },
    },

    {
      Name: "Log out and Forget Password",
      onPress: () => {
        handleLogOut_(true);
        setNavOpen({ ...isNavOpen, right: false });
      },
    },
    {
      Name: "Log out",
      onPress: () => {
        handleLogOut_();
        setNavOpen({ ...isNavOpen, right: false });
      },
    },
  ].filter((_) => _);

  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    if (path == "DashBoard") {
      option = { ...option, from: "Home", flag: "changeActiveIndex" };
    }
    (navigation || props["navigation"]).navigate(path, option || {});
  };

  return (
    <>
      <View
        style={[
          styles.container,
          web
            ? {
                position: web ? "fixed" : "sticky",
                paddingRight: isMobileWeb ? 0 : 10,
                justifyContent: "space-between",
              }
            : {
                justifyContent:
                  Dimensions.get("window").width > 400
                    ? "space-between"
                    : "space-around",
              },
        ]}
      >
        <View
          style={[
            {
              flexDirection: "row",
              padding: 10,
              justifyContent: "space-between",
            },
            !web && { flex: 1 },
            { width: "100%" },
            web && isMobileWeb
              ? {
                  paddingBottom: isDashBoard ? 10 : 23,
                  paddingRight: 0,
                }
              : {},
          ]}
        >
          <>
            <View
              style={[
                styles.navBarLeft,
                isMobileWeb
                  ? {
                      paddingLeft: 0,
                    }
                  : {},
              ]}
            >
              <TouchableOpacity
                ref={leftNavRef}
                activeOpacity={1}
                onPress={() => {
                  if (!isSmallScreen) {
                    setNavOpen({ ...isNavOpen, left: !isNavOpen["left"] });
                    handleLeftNavOpen();
                  } else if (isSmallScreen || isDashBoard) {
                    navigate("DashBoard");
                    handleClearState(isDashBoard);
                  }
                }}
              >
                <>
                  <CustomText style={{ alignSelf: "center" }} tabIndex={-1}>
                    <MaterialCommunityIcons
                      name="menu"
                      size={!isMobileWeb && web ? 55 : 37}
                    />
                  </CustomText>
                  {isNavOpen["left"] && (
                    <CustomText
                      style={{
                        position: "absolute",
                        alignSelf: "center",
                        bottom: !isMobileWeb && web ? 13 : 9,
                        backgroundColor: "#fff",
                        width: !isMobileWeb && web ? 18 : 15,
                        height: !isMobileWeb && web ? 20 : 11,
                        right: !isMobileWeb && web ? 5 : 3,
                        transform: [{ rotate: "180deg" }],
                      }}
                      bold={true}
                    >
                      <MaterialCommunityIcons
                        name="triangle"
                        size={!isMobileWeb && web ? 15 : 11}
                        style={{
                          textAlignVertical: "center",
                          textAlign: "center",
                        }}
                      />
                    </CustomText>
                  )}
                </>
              </TouchableOpacity>
              <Modal
                visible={isNavOpen["left"] && (!web || !isSmallScreen)}
                // visible={true}
                transparent
                animationType="fade"
              >
                <TouchableOpacity
                  activeOpacity={1}
                  style={{
                    width: "100%",
                    height: "100%",
                    // backgroundColor: "#87878794",
                  }}
                  onPress={() => setNavOpen({ ...isNavOpen, left: false })}
                >
                  <View
                    style={[
                      {
                        backgroundColor: "#fff",
                        position: "absolute",
                        zIndex: 2,
                        width: 310,
                        borderColor: "#d3dadf",
                        borderWidth: 2,
                        borderRadius: 5,
                        boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                        maxHeight:
                          Dimensions.get("window").height -
                          leftNavPosition.top -
                          40,
                        paddingHorizontal: 8,
                      },
                      leftNavPosition,
                      // web ? { right: 0 } : {},
                    ]}
                  >
                    <ScrollContainer>
                      <NavBarContent
                        navigate={navigate}
                        navLeftOptionState={navLeftOptionState}
                        setNavLeftOptionState={setNavLeftOptionState}
                        navLeftOption={navLeftOption}
                        {...props}
                        webviewRef={webviewRef}
                        setNavOpen={setNavOpen}
                        iFrameviewRef={iFrameviewRef}
                        inCompleteTabIndex={inCompleteTabIndex}
                      />
                    </ScrollContainer>
                  </View>
                </TouchableOpacity>
              </Modal>
            </View>

            <TouchableOpacity
              ref={DMLogoBlueRef}
              activeOpacity={1}
              onPress={() => {
                navigate("DashBoard");
              }}
              style={{ flexDirection: "row" }}
            >
              <Image
                resizeMode="contain"
                style={{
                  height: !isMobileWeb && web ? "50" : "auto",
                  width: !isMobileWeb && web ? 320 : 250,
                  // borderWidth: 1,
                }}
                source={require("../../assets/DMLogoBlue.png")}
              />

              {/* <View
                style={
                  web ? styles.titleContainerWeb : styles.titleContainerMobile
                }
              >
                <CustomText style={{ fontSize: web ? 12 : 9 }}>
                  Technical issues? Call (801) 924-1891
                </CustomText>
              </View> */}
            </TouchableOpacity>
          </>

          <View style={styles.navBarRight}>
            <TouchableOpacity
              ref={rightNavRef}
              activeOpacity={1}
              onPress={() => {
                setNavOpen({ ...isNavOpen, right: true });
                handleRightNavOpen();
              }}
              style={[styles.navButtonContainer]}
            >
              {!isDashBoard ? (
                <View
                  style={{
                    alignItems: "center",
                    fontSize: 10,
                    marginTop: !isMobileWeb && web ? -10 : -15,
                    height: !isMobileWeb && web ? 70 : 47,
                    display: hideProgress ? "none" : "flex",
                  }}
                >
                  <CustomText
                    style={{
                      fontSize: 10,
                    }}
                    bold={true}
                  >
                    Progress
                  </CustomText>
                  <CircleProgressBar progress={progressPercentage} />
                  {loanId > 0 && (
                    <CustomText
                      style={{
                        marginTop: -35,
                        fontSize: !isMobileWeb && web ? 11 : 10,
                      }}
                    >
                      {loanId}
                    </CustomText>
                  )}
                </View>
              ) : (
                <Icon
                  name="user-circle-o"
                  color="gray"
                  size={!isMobileWeb && web ? 60 : 35}
                />
              )}
            </TouchableOpacity>

            <Modal
              visible={isNavOpen["right"]}
              transparent
              animationType="fade"
            >
              <TouchableOpacity
                activeOpacity={1}
                style={{ width: "100%", height: "100%" }}
                onPress={() => setNavOpen({ ...isNavOpen, right: false })}
              >
                <View
                  style={[
                    {
                      backgroundColor: "#fff",
                      position: "absolute",
                      width: 250,
                      borderColor: "#d3dadf",
                      borderWidth: 2,
                      borderRadius: 5,
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                    },
                    rightNavPosition,
                  ]}
                >
                  <View
                    style={{
                      borderBottomColor: "#d3dadf",
                      borderBottomWidth: 2,
                    }}
                  >
                    <CustomText style={[styles.navRightOption]} bold={true}>
                      {userName}
                    </CustomText>
                  </View>
                  {navRightOption.map((item, index) => (
                    <CustomText
                      key={index}
                      onPress={item["onPress"]}
                      style={styles.navRightOption}
                    >
                      {item["Name"]}
                    </CustomText>
                  ))}
                  {!web && (
                    <TouchableOpacity
                      activeOpacity={0.7}
                      style={{
                        borderTopColor: "#d3dadf",
                        borderTopWidth: 2,
                        flexDirection: "row",
                        paddingVertical: 5,
                      }}
                      onPress={() => checkForUpdates(false)}
                    >
                      <CustomText
                        style={[
                          styles.navRightOption,
                          {
                            paddingRight: 0,
                            fontSize: 14,
                            color: "#5c5c5c",
                            paddingVertical: 5,
                          },
                        ]}
                      >
                        App Version:
                      </CustomText>
                      <CustomText
                        style={[
                          styles.navRightOption,
                          {
                            fontSize: 14,
                            color: "#5c5c5c",
                            paddingVertical: 5,
                          },
                        ]}
                        bold={true}
                      >
                        {/* {`${version} (${buildVersion})`} */}
                        {`${version}`}
                      </CustomText>
                    </TouchableOpacity>
                  )}
                </View>
              </TouchableOpacity>
            </Modal>
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    top: 0,
    zIndex: 1,
    flexDirection: "row",
    backgroundColor: "#fff",
    color: "#212529",
  },

  navBarLeft: [
    {
      fontSize: 18,
      paddingLeft: 10,
    },
  ],
  navBarRight: [
    {
      // !web
      //   ? {
      //       width: Dimensions.get("window").width - 140,
      //     }
      //   : {},
      //display: "none",
    },
  ],
  navBarRightText: {
    fontSize: web ? 18 : 16,
    paddingTop: 7,
    paddingBottom: 3,
    paddingHorizontal: 10,
    color: "#212529",
    // maxWidth: web ? 220 : 180,
  },
  navButtonContainer: {
    // backgroundColor: "#b5d472",
    // borderRadius: 15,
    paddingVertical: 3,
    paddingHorizontal: 3,
    // width: 180,
    marginHorizontal: 5,
    color: "#212529",
    // marginBottom: 10,
  },
  navButtonText: {
    color: "#fff",
    padding: 5,
    alignSelf: "center",
    fontSize: 16,
  },
  navLeftOptionWrapper: {
    ...{
      // marginHorizontal: 20,
      // borderRadius: 15,
    },
    ...(web ? { cursor: "pointer" } : {}),
  },
  navLeftOption: [
    {
      paddingVertical: 8,
      // paddingHorizontal: 10,
      paddingRight: 3,
      paddingLeft: 7,
      fontSize: 16,
      color: "#212529",
    },
  ],
  navRightOption: {
    paddingVertical: 8,
    paddingHorizontal: 10,
    fontSize: 16,
    color: "#212529",
  },
  active: {
    backgroundColor: "#b5d472",
    color: "#fff",
    overflow: "hidden",
    borderRadius: 15,
  },
  titleContainerWeb: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingVertical: 10,
    alignItems: "center",
    paddingLeft: 10,
    height: 7,
  },
  titleContainerMobile: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingVertical: 0,
    alignItems: "flex-start",
    top: 30,
    paddingLeft: 10,
    zIndex: 9999,
    height: 15,
  },
});

export default NavBar;
